const list = [
  { id: 'twitter', name: 'Twitter' },
  { id: 'facebook', name: 'Facebook', iconId: 'facebook-borderless' },
  { id: 'google', name: 'Google' },
  { id: 'apple', name: 'Apple' },
  { id: 'stumbleupon', name: 'StumbleUpon' },
  { id: 'email', name: 'Email' }
]

// Define convenience methods

function findById(providerId) {
  return list.find(provider => provider.id === providerId)
}

function getName(providerId) {
  const found = list.findById(providerId)
  return found ? found.name : providerId
}

// Attach convenience methods to `list` Array

Object.defineProperties(list, {
  findById: { value: findById },
  getName: { value: getName }
})

module.exports = list
